<template>
  <slot v-if="isEnabled" />
  <slot v-else name="disabled" />
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user';
import { type ReportableEvent } from '@/types/Analytics';
import { useAnalyticsStore } from '@/stores/analytics';
import { computed } from 'vue';

const props = defineProps<{
  name: string;
  event?: ReportableEvent;
}>();

const isEventLevel = computed(() => !!props.event);
const { hasFeature } = useUserStore();
const { eventHasFeature } = useAnalyticsStore();

// If we pass in an event, check if the event has the feature, otherwise check if the user has the feature
const isEnabled = computed(() =>
  isEventLevel.value ? eventHasFeature(props.name, props.event) : hasFeature(props.name),
);
</script>
